import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LoggedInGuard } from './shared/guards/logged-in.guard';
import { PermissionsResolver } from './trust-center/resolvers/permissions.resolver';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'tc/home'
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'tc',
    loadChildren: () => import('./trust-center/trust-center.module').then(m => m.TrustCenterModule),
    canActivate: [LoggedInGuard],
    resolve: {
      permissions: PermissionsResolver
    }
  },
  {
    path: '**',
    redirectTo: 'tc'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
